/**
 * P3-007: Hub runtime — consumes backend-resolved hub descriptor.
 */
import type { NavigationHubDescriptor, RouteId } from '@finance/contracts';
import type { ApiSuccessEnvelope } from '@finance/contracts';
import { useNavigationHubRead } from '../../api/generated/client';
import { selectApiData } from '../../api/select-api-data';
import { useSession } from '../../features/auth/session-provider';
import { buildAuthorizationFingerprint, fingerprintToArray } from '../cache/authorization-fingerprint';

export const hubQueryKey = (hubRouteId: RouteId) => ['navigation', 'hub', hubRouteId] as const;

export function useHub(hubRouteId: RouteId) {
  const { currentContext, user } = useSession();
  const fingerprint = buildAuthorizationFingerprint(user, currentContext);
  
  return useNavigationHubRead<NavigationHubDescriptor>(hubRouteId, {
    query: {
      queryKey: [
        'navigation',
        'hub',
        hubRouteId,
        ...fingerprintToArray(fingerprint),
      ],
      staleTime: 2 * 60 * 1000,
      enabled: Boolean(hubRouteId),
      select: (response: unknown) => selectApiData(response as ApiSuccessEnvelope<NavigationHubDescriptor>),
    },
  });
}
